import APIClient from '@/shared/http/clients/api'

const resourceName = 'Vistoria'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const Get = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const PostSearch = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/search?limit=${limit}&index=${index}`, data, config)
const GetAllTableSST = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllTableSST?limit=${limit}&index=${index}`, data, config)
const GetAllCabecalhoMobilePdf = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllCabecalhoMobilePdf/${id}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.Update(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${id}`, config)
const Inativar = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/inativar/${id}`, config)
const SetImg = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/img/${id}`, data, config)
const GetImgAll = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/imgAll/${id}`, config)
const GetSurveyPrint = (id, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/print/${id}`, config)
const ChangeStatusVistoria = (id, status, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/changestatus/vistoria/${id}/status/${status}`, data, config)
const changestatusTable = (id, status, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/changestatusTable/vistoria/${id}/status/${status}`, data, config)
const ReprovarStatusVistoria = (id, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/reprovar/vistoria/${id}`, data, config)
const imgVistoria = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/imgVistoria/vistoria/${id}`, data, config)
const imgVistoriaMobPdf = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/imgVistoriaMobPdf`, data, config)
const ValidarTokenPDF = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetValidarTokenAcessoPdf`, data, config)

const SurveyRepository = {
  GetAll,
  GetAllPaging,
  Get,
  PostSearch,
  GetAllTableSST,
  GetAllCabecalhoMobilePdf,
  Create,
  Update,
  Delete,
  Inativar,
  SetImg,
  GetImgAll,
  GetSurveyPrint,
  ChangeStatusVistoria,
  changestatusTable,
  ReprovarStatusVistoria,
  imgVistoria,
  imgVistoriaMobPdf,
  ValidarTokenPDF
}
export default SurveyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/Survey.js